"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FauceteerFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: false,
        inputs: [
            {
                internalType: "contract EIP20NonStandardInterface",
                name: "token",
                type: "address",
            },
        ],
        name: "drip",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610236806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c806367a5cd0614610030575b600080fd5b6100566004803603602081101561004657600080fd5b50356001600160a01b0316610058565b005b604080516370a0823160e01b815230600482015290516000916001600160a01b038416916370a0823191602480820192602092909190829003018186803b1580156100a257600080fd5b505afa1580156100b6573d6000803e3d6000fd5b505050506040513d60208110156100cc57600080fd5b5051905080610117576040805162461bcd60e51b815260206004820152601260248201527146617563657465657220697320656d70747960701b604482015290519081900360640190fd5b6040805163a9059cbb60e01b81523360048201526127108304602482015290516001600160a01b0384169163a9059cbb91604480830192600092919082900301818387803b15801561016857600080fd5b505af115801561017c573d6000803e3d6000fd5b5050505060003d6000811461019857602081146101a257600080fd5b60001991506101ae565b60206000803e60005191505b50806101fc576040805162461bcd60e51b81526020600482015260186024820152772a3930b739b332b9103932ba3ab93732b2103330b639b29760411b604482015290519081900360640190fd5b50505056fea265627a7a72315820d1a6ae84e63ced773513325a972af07f9cdc47a248ff062fc7b126440ba89a3564736f6c63430005100032";
class FauceteerFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.FauceteerFactory = FauceteerFactory;
FauceteerFactory.bytecode = _bytecode;
FauceteerFactory.abi = _abi;
//# sourceMappingURL=FauceteerFactory.js.map